module.exports = "https://www.gc-pro.gnp.com.mx/1ccdbc6b989a67fd1b0a37c7646e1d00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/05-rc.svg
// module id = 1791
// module chunks = 0